import React from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent';
import Diagram from '../../Components/Diagram';
import Turnout from '../../Components/Turnout';
import { Title, Subtitle } from '../../Components/Header';
import { percentFormat } from '../../Utils/NumberFormatting';
import Header from '../../Components/Header';
import { Left } from '../../Symbols/layout';

export default class Overview extends React.PureComponent {

	state = {
		meta: {
			turnout: 0,
			count: 0
		},
		parties: [],
		partiesPercent: [],
		partiesMandates: [],
		hasData: false
	}

	componentDidMount() {
		this.load();
	}

	load = () => {
		superagent
			.get(`${this.props.rootUrl}vysledky_souhrn.json`)
			.then((data) => {
				this.setState(Object.assign(data.body, {
					partiesPercent: data.body.parties.slice().sort((a, b) => b.percent - a.percent),
					partiesMandates: data.body.parties.slice().sort((a, b) => b.mandates - a.mandates),
					hasData: true
				}));
			}).catch(() => {});
	}

	render() {
		// Prevent rendering of refresh button and info panel when either elections are over or data is not ready yet
		const canUpdate = this.state.hasData && this.state.meta.count !== 100;

		return <>
			<Header load={this.load} canUpdate={canUpdate} />
			<Left>
				<Title.Input>Komunální volby {this.props.year}</Title.Input>
				<Subtitle.Input>Celkový přehled</Subtitle.Input>

				{!this.state.hasData && <p>
					Načítám data
				</p>}

				{this.state.hasData && this.state.partiesPercent.length === 0 && <p>
					Zatím nebyly sečteny žádné hlasy.
				</p>}

				<Diagram
					title="Kolik získaly strany hlasů"
					items={this.state.partiesPercent}
					getValue={item => item.percent}
					renderValue={item => percentFormat(item.percent)}
				/>

				<Turnout
					turnout={this.state.meta.turnout}
					count={this.state.meta.count}
				/>

				<Diagram
					title="Kolik získaly strany zastupitelů"
					items={this.state.partiesMandates}
					getValue={item => item.mandates}
				/>
			</Left>
		</>;
	}
}

Overview.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired
}
